export default (_, inject) => {
    inject('headUtil', data => ({
        htmlAttrs: {
            lang: data.lang
        },
        title: data.title,
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: data.description || "etax.one.th ระบบ e-Tax service ใบกำกับภาษีอิเล็กทรอนิกส์ ช่วยลดต้นทุนให้ธุรกิจทุกขนาด ใช้ง่าย ปลอดภัย มีมาตรฐาน",
            },
            {
                name: 'keywords',
                content: ['ภาษี','ใบกำกับภาษี','ภาษีออนไลน์','e-tax invoice','etax','บัญชี','ใบเสร็จรับเงินอิเล็กทรอนิกส์','e-Receipt','บัญชีออนไลน์','สัมมนาบัญชี','Service Provider','ใบกำกับภาษีอิเล็กทรอนิกส์', 'ช้อปดีมีคืน']
            },
            {
                name: 'og:title',
                property: 'og:title',
                content:  data.title
            },
            {
                name: 'og:description',
                property: 'og:description',
                content:  data.description || "etax.one.th ระบบ e-Tax service ใบกำกับภาษีอิเล็กทรอนิกส์ ช่วยลดต้นทุนให้ธุรกิจทุกขนาด ใช้ง่าย ปลอดภัย มีมาตรฐาน"
            },
            {
                name: 'og:url',
                property: 'og:url',
                content:  process.env.urlHostname + data.urlPath
            },
            {
                name: 'og:site_name',
                property: 'og:site_name',
                content:  data.title
            },
            {
                name: 'og:image',
                property: 'og:image',
                // eslint-disable-next-line import/no-absolute-path
                content:  data.image || require('/static/etax-inet.webp')
            }
        ],
        link: [
            {
                rel: 'canonical',
                href: data.urlPath ?  process.env.urlHostname + data.urlPath : ''
            }
        ],
        script: [
            {
                tagPosition: 'head',
                json: {'@context':'https://schema.org','@type':'WebSite','name':'ระบบ etax.one.th',  'alternateName': ['One Electronic Billing', 'etax.one.th'],'url': process.env.urlHostname + data.urlPath},
                type: 'application/ld+json',
            },
        ]
    }))
}